import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { filter } from 'rxjs';
import { sleep } from '../lib/sleep';
import { NetworkInterceptorService } from '../network-interceptor';
import { BrowserService } from './browser.service';
import { StorageService } from './storage.service';
import { ViewGalleryHierarchyService } from './view-gallery-hierarchy.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryPasswordService {
  private networkInterceptor = inject(NetworkInterceptorService);
  private storage = inject(StorageService);
  private viewGalleryHierarchyService = inject(ViewGalleryHierarchyService);
  private platformId = inject(PLATFORM_ID);
  private browserService = inject(BrowserService);
  passwords: { [galleryId: string]: string };

  private initted = false;

  init() {
    this.initted = true;
    this.passwords = this.storage.get('galleryPasswords') || {};
  }

  watcher = this.networkInterceptor.error$.pipe(filter(Boolean)).subscribe(({ error }) => {
    const code = error?.error?.code;
    if (isPlatformServer(this.platformId)) return;
    if (code === 'password_invalid' || code === 'password_required') {
      this.removeAllPasswords();
      // eslint-disable-next-line no-debugger
      debugger;
      sleep(250).then(() => {
        this.browserService.reload(true);
      });
    }
  });

  getPassword(galleryId: string, isSubLookup = false): string {
    if (!galleryId) return;
    if (!this.initted) this.init();
    if (this.passwords[galleryId]) return this.passwords[galleryId];
    if (isSubLookup) return;
    const gallery = this.viewGalleryHierarchyService.getParent(galleryId);
    if (gallery) return this.getPassword(gallery.galleryId);
    const children = this.viewGalleryHierarchyService.getChildren(galleryId);
    return children?.map(child => this.getPassword(child, true)).join('');
  }

  setPassword(galleryId: string, password: string) {
    if (!this.initted) this.init();
    this.passwords[galleryId] = password;
    this.storage.set('galleryPasswords', this.passwords);
  }

  removePassword(galleryId: string) {
    if (!this.initted) this.init();
    delete this.passwords[galleryId];
    this.storage.set('galleryPasswords', this.passwords);
  }

  removeAllPasswords() {
    if (!this.initted) this.init();
    this.passwords = {};
    this.storage.set('galleryPasswords', this.passwords);
  }
}
